// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WITRPMbhEbMTpNKTdtO4{background:var(--gray-a-15);border-radius:4px;justify-content:center;align-items:center;gap:8px;width:-webkit-fit-content;width:fit-content;padding:3.5px 8px;display:flex}.spm4rOSEzQyIYtygnLvm{background:var(--content-neutral-primary);width:1px;height:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upgradeLabel": `WITRPMbhEbMTpNKTdtO4`,
	"separator": `spm4rOSEzQyIYtygnLvm`
};
export default ___CSS_LOADER_EXPORT___;
